import type { DateIso } from '../../../types/domain';
import { dateFromIso, diffDays } from '../base';

/* Part de la période déjà écoulée (0 à 1), jour du jour compris : sert au point « temps écoulé »
   d'un forfait. null sans date de début ou de fin. */
export function elapsedShare(
  startIso: DateIso | null | undefined,
  endIso: DateIso | null | undefined,
  todayIso: DateIso,
): number | null {
  if (!startIso || !endIso || endIso < startIso) return null;
  const total = diffDays(dateFromIso(startIso), dateFromIso(endIso)) + 1;
  const done = diffDays(dateFromIso(startIso), dateFromIso(todayIso)) + 1;
  return Math.min(1, Math.max(0, done / total));
}
